//@todo flyttes til nfg2 felles
export function uriEnkodet(verdi: string): string {
    return encodeURIComponent(verdi);
}

export function uriDekodet(verdi: string): string {
    if (!verdi) return verdi;
    return decodeURIComponent(verdi);
}
